jQuery(document).ready(function ($) {

       document.addEventListener('userway:init_completed', function (event) {
           window.addEventListener("klaviyoForms", function(e) { 
        if (e.detail.type == 'open') {
            setTimeout(() => {
              let formElement = $(".klaviyo-form[data-testid='klaviyo-form-" + e.detail.formId + "']");
              let overallElement = formElement.parent().parent().parent().parent().parent().parent();
              let closeButton = overallElement.find(".klaviyo-close-form");
              $(closeButton).on("click", function() {
                overallElement.css("display", "none");
              });
          }, 1000);
        }
    });
    });

  
  /*** Aria hidden elements focusable fix ***/
  $('.hero.flickity-enabled .slideshow__slide:not(.is-selected)').attr("aria-hidden", false);
  $('.hero.flickity-enabled .slideshow__slide:not(.is-selected) *').attr("aria-hidden", false);
  $('.wb-fp-carousel.flickity-enabled .carousel-cell:not(.is-selected)').attr("aria-hidden", false);
  $('.wb-fp-carousel.flickity-enabled .carousel-cell:not(.is-selected) *').attr("aria-hidden", false);
  /*** Empty Gift Card Product Hide ***/
  $(".gg_grid-item").each(function(){
      if($('.gg_grid-image', this).length === 0){
        $(this).hide();
      }
  });
  $('.universal-header-list-container li img, .simple-slide-content, .customBlockContent').css('opacity', 1);
});

